import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "card-header card-header-stretch" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 新建稀有度 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vxe_input = _resolveComponent("vxe-input")!
  const _component_vxe_form_item = _resolveComponent("vxe-form-item")!
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vxe_form = _resolveComponent("vxe-form")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vxe_form, {
        data: _ctx.formData,
        onSubmit: _ctx.submitEvent
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_form_item, {
            field: "name",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                placeholder: "稀有度名称"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "submit",
                status: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.onReset
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                to: { name: 'card_rarities_new' },
                class: "btn btn-success ms-2"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onSubmit"])
    ]),
    _createVNode(_component_vxe_table, {
      data: _ctx.tableData,
      "row-config": { isHover: true }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          field: "id",
          title: "ID",
          width: "60"
        }),
        _createVNode(_component_vxe_column, {
          field: "name",
          title: "名称",
          width: "150"
        }),
        _createVNode(_component_vxe_column, {
          title: "卡牌数",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.cards_count || 0), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "sort",
          title: "排序",
          width: "80"
        }),
        _createVNode(_component_vxe_column, {
          field: "created_at",
          title: "创建时间",
          width: "160"
        }),
        _createVNode(_component_vxe_column, {
          title: "操作",
          width: "150",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: ($event: any) => (_ctx.$router.push({ name: 'card_rarities_edit', params: { id: row.id } }))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: ($event: any) => (_ctx.onDelete(row)),
              disabled: (row.cards_count || 0) > 0
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 2
            }, 1032, ["onClick", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_vxe_pager, {
      "current-page": _ctx.page.currentPage,
      "onUpdate:current-page": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.page.currentPage) = $event)),
      "page-size": _ctx.page.pageSize,
      "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.page.pageSize) = $event)),
      total: _ctx.page.totalResult,
      layouts: [
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ],
      onPageChange: _ctx.onPageChange
    }, null, 8, ["current-page", "page-size", "total", "onPageChange"])
  ]))
}